/* Indoor Hunter: small UI behaviours for custom sections. */
(function () {
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!customElements.get('ih-slideshow')) {
    class IhSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.ih-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
        if (this.slides.length < 2) return;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1));
        this.dots.forEach((dot, i) =>
          dot.addEventListener('click', () => {
            this.go(i);
            this.restart();
          })
        );

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        let startX = null;
        this.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
        this.addEventListener(
          'touchend',
          (e) => {
            if (startX === null) return;
            const dx = e.changedTouches[0].clientX - startX;
            if (Math.abs(dx) > 40) this.step(dx < 0 ? 1 : -1);
            startX = null;
          },
          { passive: true }
        );

        this.onBlockSelect = (e) => {
          const slide = e.target.closest ? e.target.closest('.ih-hero__slide') : null;
          const i = this.slides.indexOf(slide);
          if (i > -1) {
            this.stop();
            this.go(i);
          }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      step(delta) {
        this.go(this.index + delta);
        this.restart();
      }

      go(i) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.slides.forEach((slide, k) => {
          const active = k === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
        });
        this.dots.forEach((dot, k) => {
          dot.classList.toggle('is-active', k === this.index);
          dot.setAttribute('aria-current', k === this.index ? 'true' : 'false');
        });
      }

      start() {
        if (this.dataset.autoplay !== 'true' || reduceMotion()) return;
        if (window.Shopify && window.Shopify.designMode) return;
        this.stop();
        this.timer = window.setInterval(() => this.go(this.index + 1), parseInt(this.dataset.speed, 10) || 7000);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }
    }
    customElements.define('ih-slideshow', IhSlideshow);
  }

  if (!customElements.get('ih-carousel')) {
    class IhCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ih-carousel');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;

        this.prev?.addEventListener('click', () => this.page(-1));
        this.next?.addEventListener('click', () => this.page(1));
        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }

      page(direction) {
        const card = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 20;
        const amount = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
        this.track.scrollBy({ left: direction * amount, behavior: reduceMotion() ? 'auto' : 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      }
    }
    customElements.define('ih-carousel', IhCarousel);
  }
})();
